import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const PrintingOfHangtags = () => {

  const servicesFaqData = [
    { 
        question: "What customisation options are available for hangtag printing?", 
        answer: "Printingy offers extensive customisation options for hangtag printing, including sizes, shapes, materials, and finishes. Our hangtags for garments services allow you to include logos, colours, and product details tailored to your brand. Additional features like embossing, foiling, and die-cut designs can further enhance the visual appeal of your hangtags."
    },
    { 
        question: "Does Printingy handle bulk orders for hangtag printing?", 
        answer: "Yes, Printingy specialises in hangtag printing in bulk, ensuring consistent quality across all pieces. Bulk printing is ideal for garment manufacturers, retail stores, and fashion brands requiring large quantities of hangtags for their collections. Our efficient production processes guarantee reliable and timely delivery for all bulk orders."
    },
    { 
        question: "What industries benefit from custom hangtag printing services?", 
        answer: "Hangtag printing services are widely used in the garment and retail industries. Fashion brands and manufacturers rely on hangtags for garments for product branding, pricing, and care instructions. Printingy provides tailored hangtags print for garments solutions that meet the unique requirements of each industry, ensuring professional and impactful results."
    },
    { 
        question: "What materials and finishes are available for hangtags?", 
        answer: "We use high-quality materials for hangtag printing on garments, including eco-friendly options like recycled paper or kraft card stock. Finishes such as matte, glossy, UV coating, or textured materials enhance your hangtags' durability and aesthetic appeal. These options ensure your products maintain a professional appearance while aligning with your branding."
    },
    { 
        question: "Does Printingy provide design assistance for hangtags?", 
        answer: "Yes, our custom hangtags for garments services include professional design assistance. Whether you have a concept in mind or need creative input, our design team collaborates with you to produce engaging and functional layouts. From font selection to colour schemes, we ensure every detail aligns with your brand and purpose."
    },
    { 
        question: "What is the typical turnaround time for hangtag printing?", 
        answer: "Turnaround times for bulk hangtag printing depend on the order's size and complexity. Standard bulk orders are typically completed within a few business days. For highly customised designs or larger volumes, we provide clear timelines and prioritise meeting your deadlines without compromising quality."
    },
    { 
        question: "Are eco-friendly options available for hangtag printing?", 
        answer: "Yes, Printingy is committed to sustainability and offers eco-friendly options for garment hangtags. We use recyclable materials, non-toxic inks, and sustainable production methods to minimise environmental impact. These options are ideal for businesses aligning their branding with eco-conscious values."
    },
    { 
        question: "What factors should I consider when ordering custom hangtags?", 
        answer: "When ordering custom hangtags for garments, consider the purpose, target audience, and product details to include. Choosing the right material, size, and design elements ensures your hangtags are effective and visually appealing. Printingy’s team guides the process to help you create hangtags that achieve your goals."
    },
    { 
        question: "How do I place an order for hangtag printing services?", 
        answer: "Placing an order is simple and efficient. Visit our website and select your preferences for hangtag printing. Upload your design files or share your requirements, and our team will guide you through the process. We ensure a seamless experience from design approval to delivery."
    },
    { 
        question: "What makes bulk hangtag printing cost-effective?", 
        answer: "Bulk hangtag printing reduces per-unit costs, making it an economical choice for large-scale production. Printingy delivers high-quality results at competitive prices by consolidating materials and streamlining production. Our hangtag printing in bulk services ensures exceptional value while maintaining professional standards."
    }
];

    
const [pageTitle, setPageTitle] = useState('Printing Of Hangtags');  // Dynamic title state

useEffect(() => {
  document.title = pageTitle; // Set the document title dynamically
}, [pageTitle]); // This will run whenever the pageTitle changes


  return (
    <div>
    <MetaManager 
  title="Custom Hangtag Printing for Garments"
  description=" Professional hangtag printing for garments. Bulk printing solutions with custom hangtags for garments and high-quality hangtags print for branding."
  keywords="Printing of Hangtags
Hangtag printing, Hangtag printing in bulk , Hangtags for garments,Hangtags print for garments
"
/>


      <header className="services-header text-center py-5  serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Hangtag Printing Services</h1>
              <h2 className="text-muted">Custom hangtags for garments designed for effective branding</h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Hangtags are essential for branding and product information in the garment industry. Printingy offers premium-quality hangtag printing services, specialising in hangtags for garments with tailored designs to enhance your brand’s appeal.</p>
          <p>Our hangtag printing in bulk solutions is ideal for garment manufacturers, retailers, and fashion brands. We provide a range of options, including eco-friendly materials, vibrant printing, and durable finishes. Whether for pricing, product details, or branding, our hangtags are designed to leave a lasting impression.</p>
          <p>With flexible customisation options and consistent quality across all orders, Printingy ensures your hangtags print for garments meets professional standards. Let us handle your hangtag needs with precision and efficiency.</p>
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3 rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Customised Hangtags for Branding </h2>
                <h3 className="large-hed">Affordable, durable, and eco-friendly hangtag printing services</h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Customised hangtags for garments with premium finishes.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk hangtag printing in bulk for cost-effective solutions.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Eco-friendly materials for sustainable branding practices.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Vibrant colours, sharp text, and long-lasting durability.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnarounds and efficient order management systems.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Advanced printing technology for detailed and professional designs.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted by garment manufacturers, fashion retailers, and designers nationwide.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Competitive pricing for large-scale orders without compromising quality.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/hangtagprints.jpg" // Path relative to the public folder
                  alt="Custom hangtags for garment printing"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
       title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Hangtags Delivered On Time</h2>
            <h3 className="small-hed">Focus on your garments while we handle your hangtag printing needs</h3>
            <p>At Printingy, we combine advanced printing technology with expert craftsmanship to deliver exceptional hangtag printing services. Whether you need hangtag printing in bulk for large-scale production or customised designs for a boutique collection, we ensure consistent quality and timely delivery.</p>
            <p>Our commitment to excellence guarantees that your hangtags print for garments will reflect your brand’s professionalism and enhance your product presentation. Partner with Printingy for reliable hangtag solutions that stand out.
            </p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default PrintingOfHangtags;
